import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditUserLoginLogoutable from "../components/UserLoginLogout";

export default function AuditUserLoginLogout() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('User LoginLogout Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditUserLoginLogoutable />
        </Layout>
    )
}